import {useContext} from 'react';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {customizedListItem, TableColumn, TableSettings} from '../../../tableSettings';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer } from '../../../uiControls/SmartTableRenderers';
import {JobNames} from '../../../framework.core/JobNames';
import ApplicationContext from '../../../ApplicationContext';
import { EdiExcelUploadListItem } from '../../../fms.data/models/EdiExcelUploadListItem';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import * as XCol from '../../../framework.core/XExportColumn';
import { now } from '../../../dateUtils';

function formatData(data:Array<EdiExcelUploadListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function ListCommands() {
  const appContext = useContext(ApplicationContext);

  return (
    <div className="ifms-common-no-vertical-separator">
      <></>
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

/**
 * Concrete implementation for Special Report List screen
 *
 * @class EdiExcelUploadListView
 * @extends {AbstractListView}
 */
 class EdiExcelUploadListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.CustomizedList,
      'EdiExcelUploadListItem',
      EdiExcelUploadListItem.calculateSearchParameters(search),
      pageNum,
      0,
      search.pageSize,
      search.pagePerBatch
    );
     if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
       return { data: [], totalCount: 0 };
     }
     const totalCount = limit > 0 ? Math.min(apiResult.totalCount, limit) : apiResult.totalCount;

     return { data: formatData(apiResult.entities).slice(0, totalCount), totalCount: totalCount, displayTotalCount: apiResult.totalCount };
   }
  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(
      JobNames.CustomizedList,
      'EdiExcelUploadListItem',
      EdiExcelUploadListItem.calculateSearchParameters(search),
      pageNum,
      0,
      pageSize,
      pagePerBatch
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return EdiExcelUploadListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.type === XCol.XCellType.Bool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex.toUpperCase() === 'F_ID' || x.dataIndex.toUpperCase() === 'ID')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} useComma={false} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    return [];
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: '',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = customizedListItem;
    const cols = EdiExcelUploadListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <></>;
  }

  getViewUrlFor(row: EdiExcelUploadListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Customized List';
  };

  hasRightClickContext(): boolean {
    return false;
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default EdiExcelUploadListView;
